














// @ts-ignore
import { formatDate } from "@/utils/luxon";
import { BAlert } from "bootstrap-vue";
import { computed } from "@vue/composition-api";
// @ts-ignore
import useUsers from "@/composables/useUsers";
import UserInterface from "@/interfaces/user.interface";
// @ts-ignore
import i18n from "@/libs/i18n";

export default {
    components: {
        BAlert,
    },
    props: {
        channel: {
            type: Object,
            required: true,
        },
        entry: {
            type: Object,
            required: true,
        },
        groupDirection: {
            type: String,
            required: false,
        },
    },
    // @ts-ignore
    setup(props) {
        const { users } = useUsers();
        const authorName = computed(() => {
            const user = users.value.find((user: UserInterface) => user.id === props.entry.userId);
            if (!user) {
                return i18n.t("someone"); // Fallback if no user could be found (Maybe it's a hidden user?)
            }
            return user.name;
        });

        const time = computed(() => {
            if (!props.entry.time) {
                return "";
            }
            return formatDate(props.entry.time, {
                hour: "2-digit",
                minute: "2-digit",
            });
        });

        return {
            authorName,
            time,
        };
    },
};
